import { UploadForm } from './UploadForm'
export const ToastySubmit = () => {
  return (
    <>
      <main className="sm:px-6 lg:px-8">
        <UploadForm />
      </main>
    </>
  )
}
